var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIsNotNull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#IsNotNull_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.813 15.547c-1.6-.021-2.399-.828-2.399-2.422v-2.344c0-1.052-.406-1.604-1.219-1.656v-.906c.813-.052 1.22-.615 1.22-1.688V4.25c0-1.615.799-2.432 2.397-2.453v1c-.828.02-1.242.536-1.242 1.547v2.289c0 1.094-.39 1.765-1.172 2.015v.032c.782.234 1.172.9 1.172 2v2.258c0 .578.091.99.274 1.234.187.25.51.38.968.39v.985zm5.007-6.422c-.812.052-1.218.604-1.218 1.656v2.344c0 1.594-.797 2.401-2.391 2.422v-.985c.453-.01.773-.14.96-.39.194-.25.29-.662.29-1.235V10.68c0-1.1.388-1.766 1.164-2v-.032c-.776-.25-1.164-.921-1.164-2.015v-2.29c0-1.01-.417-1.525-1.25-1.546v-1c1.594.02 2.39.838 2.39 2.453v2.281c0 1.073.407 1.636 1.22 1.688v.906z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C6C6C6",
    d: "M14.367 2.339l-12 13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IsNotNull_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

export default SvgIsNotNull;